import { acceptHMRUpdate, defineStore } from 'pinia'

import {
  createError, useApi
} from '#imports'
import { GLOBALS } from '~/graphql/globals'

export const useGlobalStore = defineStore('global', {
  state: () => ({
    catalog: null,
    abstract: null,
    address: {},
    marketCode: null,
    seo: {},
    socials: [],
    prefooter: null
  }),

  actions: {
    async getData () {
      try {
        // TODO: Implement actual GraphQL call when schema is ready
        const { config } = await useApi(GLOBALS)

        this.seo = {
          title: config?.seo?.metaTitle,
          description: config?.seo?.metaDescription,
          image: config?.seo?.metaOgImage,
          suffix: config?.metaSuffix
        }

        // this.catalog = getFirst(config.document)
        // this.abstract = config.abstract

        // this.address = {
        //   streetAddress: config.streetAddress,
        //   postalCode: config.postalCode,
        //   city: config.city,
        //   district: config.district,
        //   country: config.country,
        //   phone: config.phone,
        //   fax: config.fax,
        //   vatCapSoc: config.vatCapSoc
        // }

        // this.socials = config.socials

        this.prefooter = null

        // console.log('[INFO] Global data loaded (mock)')
      } catch (err) {
        console.error('[ERROR] Error fetching global data', err)

        throw createError({
          statusCode: 500,
          statusMessage: 'Server error'
        })
      }
    }
  },

  getters: {
    socialNetworks: state => {
      const socials = state.socials
      if (!socials) return null
      const arr = []
      for (const property in socials) {
        const single = {
          name: property,
          link: socials[property],
          icon: property
        }
        arr.push(single)
      }
      return arr.filter(i => i && i.link)
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useGlobalStore, import.meta.hot))
}
